import { Injectable } from '@angular/core';
import {
  CanActivate,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GuardService } from './service/guard.service';

@Injectable({
  providedIn: 'root'
})
export class InternalCertificateGuard implements CanActivate {
  constructor(
    private guardService: GuardService
  ) { }

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.isEnableInternalCertificateSign();
  }

  isEnableInternalCertificateSign(): Observable<boolean | UrlTree> {
    return this.guardService.activeInternalCertificate()
      .pipe(
        map((status) => {
          if (status === true) {
            return true;
          } else {
            return false;
          }
        })
      );
  }
}
